//Regex for form input validation
export const emailRegex = /^\S+@\S+\.\S+$/;
export const phoneRegex = /^[0-9]{10}$/;
export const quantityRegex = /^[1-9][0-9]*$/;
export const GSTRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[0-9A-Z]{1}$/;
export const googleTrackingId = "G-SVDPM91V71"
export const chicletOptions = [
    { label: 'Get Quotes', value: 'get quotes' },
    { label: 'Get Prices', value: 'get prices' },
    { label: 'Become a Supplier', value: 'become a supplier' }
  ];
